import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetPackageDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/package/${id}`);
}

export function apiGetAllPackages(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/packages`);
}

export function apiGetAllPackagesForProductAndBase(
  productId: number,
  baseId: number
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/packages/${productId}/${baseId}`);
}

export function apiGetAllPackagesByProductGroup(
  groupId
): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/packages/product-group/${groupId}`);
}
export function apiGetAllPackagesByProduct(productId): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/packages/product/${productId}`);
}

export function apiCreateOrUpdatePackage(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/packagecreateorupdate`, data);
}

export function apiDeletePackage(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/package/${id}`);
}
